import React, {Component} from 'react';
import {Col, Card, CardBody, Row} from 'reactstrap';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import Collapse from '../../../components/Collapse';
import EquipmentTableProfit from './EquipmentTableProfit'
import LoadingProgress from '../../../components/LoadingProgress'

class EquipmentManagersProfit extends Component {

    constructor(props) {
        super(props);
        this.state = {
            windowType: 0,
            selectedID: '0',
            saving: false,
            error: false
        };
    }


    render() {

        let isLoading = this.props.status === 'request';

        let data = [];

        if(this.props.data) {
            //console.log(this.props.data)

            for (let key in this.props.data) {

                data.push(key);

                /*console.log(key);
                console.log(this.props.data.equipStoreManagers[key]);*/
            }
        }

        return (
            <Row style={{flexDirection: "row-reverse"}}>
                {isLoading && <Col md={4}>
                    <LoadingProgress/>
                </Col>}
                {!isLoading && this.state.windowType === 0 && <Col md={12} lg={12}>
                    <Card>
                        <CardBody>
                            {data.map((item,index) => {

                                return (<Collapse title={item} className="with-shadow">
                                    <EquipmentTableProfit data={this.props.data[item]} managers={true}/>
                                </Collapse>)

                            })}
                        </CardBody>
                    </Card>
                </Col>}
            </Row>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        status: state.equipment.status,
        data: state.equipment.data.equipProfit,
        userData: state.userData
    };
};

export default withRouter(connect(mapStateToProps)(EquipmentManagersProfit))